/**
 * Konfigurasjon for Sølvrev sine Monday prosjekt-boards. Brukes av
 * admin-import-flyt for prosjektoppdateringer (kommentarer) for å la
 * superadmin velge hvilket board det importeres fra.
 *
 * Speiler BOARD_CONFIGS i supabase/functions/sync-monday-projects/index.ts
 * — hold disse i sync når nye boards legges til.
 */

export interface MondayProjectBoard {
  id: number;
  label: string;
  /** Kort beskrivelse vist i UI for å hjelpe admin å velge riktig board. */
  description?: string;
}

export const PROJECT_BOARDS: MondayProjectBoard[] = [
  {
    id: 72956552,
    label: "Aktive prosjekter",
    description: "Hovedboardet med pågående produksjoner",
  },
  {
    id: 18393874478,
    label: "2026 ferdige prosjekter",
    description: "Arkiv-board for prosjekter ferdigstilt i 2026",
  },
];
